import React from 'react'
import { useTranslation } from 'react-i18next'
const { startCase } = require('lodash')

const AdsView = ({ onHide, item }) => {
  const { t } = useTranslation()

  return (
    <div>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => onHide(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto'>
                <div className=' border-2 rounded-md p-5'>
                  <div className='grid grid-cols-2 '>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_BANNER_TYPE')}:</strong>
                      </div>
                      <div>{startCase(item?.bannerType)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className='px-2'>
                        <div
                          className='w-24 h-24 m-auto'
                          style={{ marginBottom: 20 }}
                        >
                          <img
                            style={{ height: '100%', borderRadius: '20%' }}
                            alt=''
                            src={item?.bannerImage}
                          />
                        </div>{' '}
                      </div>
                    </div>
                  </div>
                  <div className='mb-3'>
                    <div className=''>
                      <strong>{t('O_BANNER_DESCRIPTION')}:</strong>
                    </div>
                    <div>{startCase(item?.description)}</div>
                  </div>
                  <div className='mb-3'>
                    <div className=''>
                      <strong>{t('O_BANNER_DESCRIPTION') + t('O_ARABIC')}:</strong>
                    </div>
                    <div>{item?.descriptionAr}</div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => onHide(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </div>
  )
}

export default AdsView
